import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-underhead',
  templateUrl: './underhead.component.html',
  styleUrls: ['./underhead.component.scss']
})
export class UnderheadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/underhead/underhead.component.ts